import * as HeaderServices from '../header-services/header-services';
import { closePanel, slideoutPanel, openPanel, updatePanel } from '../slideout-panel/slideout-panel';
import { fetchText, fetchJSON } from '../fetch-helper/fetch-helper';
import { customSelect } from '../custom-select/custom-select';
import { togglePasswordVisibility, gtag } from '../utility-functions/utility-functions';
import { validatePassword } from '../validate-form/validate-form';
import { clearAlert, updateAlert } from '../alerts/alerts'

// TODO: Dynamic Yield Remove
//import { DynamicYieldLoginEvent, DynamicYieldSignUpEvent } from "../dynamic-yield/dynamic-yield";

const DEFAULT_LOGIN_URL = "/account/index/loginpost";
const DEFAULT_REGISTER_URL = "/account/index/registerpost";
const REDIRECT_URL = "/account";

type queryStringParams =
    {
        key?: string,
        value?: string
    }

type loginProps = {
    login?: {
        url?: string
        redirectUrl?: string
        callback?: () => void
        extraQueryStrings?: Array<queryStringParams>
    },
    register?: {
        url?: string
        redirectUrl?: string
        callback?: () => void
        extraQueryStrings?: Array<queryStringParams>
    }
}

export function login(props?: loginProps) {
    slideoutPanel();
    const instances = document.querySelectorAll('.js-login-register') as NodeListOf<HTMLElement>;

    if (instances.length > 0) {
        instances.forEach((button) => {
            button.addEventListener('click', (e) => {
                if (button.closest('.nav-drawer')) return;
                e.preventDefault();

                const session = HeaderServices.getData();

                session.then((data) => {

                    if (data.isLoggedIn) {
                        location.href = '/account/manage';
                    } else {
                        openPanel('Login', fetchLogin(props));
                    }
                });
            });
        });
    }
}

const fetchLogin = (props?: loginProps) => {
    console.log('open login');
    const currentURL = window.location.href;


    var url = `/account`;

    if (currentURL.includes('/custom-made/configurator')) {
        var url = `/account?showRegister`;
    }

    const data = fetchText(url, null);

    data.then(html => {
        updatePanel('Login', html);
        initLoginForms(props);
    });
}


export const openLogin = (props?: loginProps) => {
    openPanel('Login', fetchLogin(props));
}

export const closeLogin = () => {
    closePanel('Login');
}

const getSlideoutRoot = () =>
    document.querySelector('.slideout-module[data-id="Login"]') as HTMLElement | null;

const handleShowRegister = (root: ParentNode) => {
    const btn = root.querySelector('.js-show-register') as HTMLElement | null;
    const login = root.querySelector('[data-panel="login"]') as HTMLElement | null;
    const register = root.querySelector('[data-panel="register"]') as HTMLElement | null;

    if (btn && login && register) {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            login.classList.add('d-none');
            register.classList.remove('d-none');
        });
    }
}

const handleShowLogin = (root: ParentNode) => {
    const btn = root.querySelector('.js-show-login') as HTMLElement | null;
    const login = root.querySelector('[data-panel="login"]') as HTMLElement | null;
    const register = root.querySelector('[data-panel="register"]') as HTMLElement | null;

    if (btn && login && register) {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            login.classList.remove('d-none');
            register.classList.add('d-none');
        });
    }
}

const handlePasswordValidation = (root: ParentNode) => {
    root.querySelectorAll('.js-validate-password').forEach(item => {
        item.addEventListener('keyup', e => {
            e.preventDefault();
            const value = e.target as HTMLInputElement;
            const context = value.closest('.form-group--notifacation') as HTMLElement | null;

            validatePassword(value.value, context)
                .then(() => console.log('password validated'))
                .catch(() => console.log('password error'));
        });
    });
}


const handleLoginSubmitPost = (root: ParentNode) => {
    const loginForm = root.querySelector('#LoginForm') as HTMLFormElement | null;

    if (loginForm) {

        loginForm.addEventListener('submit', async (e) => {
            e.preventDefault();

            const data = new FormData(loginForm);
            const formObject: any = {};

            data.forEach((value, key) => {
                formObject[key] = value;
            });

            let errors = [];

            if (formObject.email === '') {
                errors.push({ error: "The password field is empty." });
            }

            if (formObject.password === '') {
                errors.push({ error: "The confirm password field is empty." });
            }


            if (errors.length === 0) {

                try {
                    const response = await fetch(DEFAULT_LOGIN_URL, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(formObject)
                    });

                    if (response.ok) {
                        console.log(response);

                    }
                } catch (error) {
                    console.log(error);
                }
            } else {
                updateAlert('account', '', errors[0].error, 'error');
            }
        });
    }
}



const handleLoginSubmitGet = (root: ParentNode, url?: string, redirectUrl?, callback?, extraQueryData?) => {
    const loginForm = root.querySelector('#LoginForm') as HTMLFormElement | null;

    if (loginForm) {
        loginForm.addEventListener('submit', async (e) => {
            e.preventDefault();

            const button = loginForm.querySelector('button[type=submit]');
            button?.setAttribute('disabled', 'disabled');

            const data = new FormData(loginForm);
            const queryParams = new URLSearchParams();
            const formObject: any = {};

            data.forEach((value, key) => {
                formObject[key] = value;
            });

            data.forEach((value, key) => {
                //@ts-ignore
                queryParams.append(key, value);
            });

            if (extraQueryData?.length > 0) {
                extraQueryData.forEach((query) => {
                    formObject[query.key] = query.value;
                });

                extraQueryData.forEach((query) => {
                    queryParams.append(query.key, query.value);
                });
            }

            let errors = [];

            if (formObject.email === '') {
                errors.push({ error: "The password field is empty." });
            }

            if (formObject.password === '') {
                errors.push({ error: "The confirm password field is empty." });
            }

            if (errors.length > 0) {
                updateAlert('account', '', errors[0].error, 'error');
                button?.removeAttribute('disabled');
                return;
            }

            const queryString = queryParams.toString();
            const requestUrl = url ? `${url}?${queryString}` : `${DEFAULT_LOGIN_URL}?${queryString}`

            try {
                const response = await fetch(requestUrl);

                if (response.ok) {
                    const json = await response.json();
                    handleResponse(json, button, redirectUrl, formObject, callback);
                    gtag('event', 'user_logged_in', {
                        'user_logged_in': true
                    });
                    const isCustomMade = document.querySelector<HTMLBodyElement>('body')?.classList.contains('custom-made-configurator');
                    if (!isCustomMade) button?.removeAttribute('disabled');
                }

            } catch (error) {
                console.log(error);
                button?.removeAttribute('disabled');
            }
        });
    }
}


const handleRegisterSubmitGet = (root: ParentNode, url?: string, redirectUrl?, callback?, extraQueryData?) => {
    const registerForm = root.querySelector('#RegisterForm') as HTMLFormElement | null;

    if (registerForm) {
        registerForm.addEventListener('submit', async (e) => {
            e.preventDefault();

            const button = registerForm.querySelector('button[type=submit]');
            button?.setAttribute('disabled', 'disabled');

            const data = new FormData(registerForm);
            const queryParams = new URLSearchParams();
            const formObject: any = {};

            data.forEach((value, key) => {
                formObject[key] = value;
            });

            data.forEach((value, key) => {
                //@ts-ignore
                queryParams.append(key, value);
            });

            let errors = [];

            if (formObject.email === '') {
                errors.push({ error: "The Email field is empty" });
            }

            const nonMatchingPasswords = formObject.Password !== formObject.PasswordConfirm;
            if (errors.length > 0 || nonMatchingPasswords) {
                nonMatchingPasswords ? updateAlert('passwordError', '', 'Your passwords do not match', 'error') : updateAlert('account', '', errors[0].error, 'error');
                button?.removeAttribute('disabled');
                return;
            }
            clearAlert('passwordError');

            const queryString = queryParams.toString();
            const requestUrl = url ? `${url}?${queryString}` : `${DEFAULT_REGISTER_URL}?${queryString}`;

            try {
                const response = await fetch(requestUrl);

                if (response.ok) {
                    const json = await response.json();
                    handleResponse(json, button, redirectUrl, formObject, callback);
                    gtag('event', 'user_sign_up', {
                        'method': 'email'
                    });
                    const isCustomMade = document.querySelector<HTMLBodyElement>('body')?.classList.contains('custom-made-configurator');
                    if (!isCustomMade) button?.removeAttribute('disabled');
                }

            } catch (error) {
                console.log(error);
                button?.removeAttribute('disabled');
            }
        });
    }
}

const handleResponse = (response, button, redirectUrl?, formObject?, callback?) => {
    redirectUrl = response.redirectUrl ? response.redirectUrl : REDIRECT_URL;

    if (response.success) {

        // TODO: Dynamic Yield Remove
        //if (formObject.Type === 'login') DynamicYieldLoginEvent(formObject.Email);
        //if (formObject.Type === 'register') DynamicYieldSignUpEvent(formObject.Email)

        if (!callback) window.location.href = redirectUrl;
        if (callback) callback(response);
    } else {
        console.log(response.errors[0]);
        updateAlert('account', '', response.errors[0], 'error');
        setTimeout(() => button && button?.removeAttribute('disabled'), 1000);
    }
}

export const initLoginForms = (props?: loginProps, rootOverride?: ParentNode) => {
    const slideoutRoot = getSlideoutRoot();
    const root: ParentNode = rootOverride ?? slideoutRoot ?? document;

    handleShowRegister(root);
    handleShowLogin(root);
    handlePasswordValidation(root);
    togglePasswordVisibility();
    handleLoginSubmitGet(root, props?.login?.url, props?.login?.redirectUrl, props?.login?.callback, props?.login?.extraQueryStrings);
    handleRegisterSubmitGet(root, props?.register?.url, props?.register?.redirectUrl, props?.register?.callback, props?.register?.extraQueryStrings);

    const context = root.querySelector('[data-panel="register"]') as HTMLElement | null;

    if (context) {
        customSelect(context, () => { });
    }
}